const QueryParameter = {
  whitelist: [
    'lang',
    'fis_persid',
    'ou',
    'compact',
    'year',
    'status',
    'funding',
    'person',
    'freetext',
    'externalPartner',
    'category',
    'sdg',
    'sortOrder',
    'sortField'
  ],
  clean (toQuery) {
    Object.keys(toQuery).forEach(param => {
      if (!this.whitelist.includes(param)) {
        delete toQuery[param]
      }
    })
    return toQuery
  },
  hasBlacklistedParam (toQuery) {
    return Object.keys(toQuery).some(param => !this.whitelist.includes(param))
  }
}

export default QueryParameter



// WEBPACK FOOTER //
// ./src/router/QueryParameter.js